import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        job_positions: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        job_positionMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getJob_positionsRequest({dispatch}) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveJob_positions", null);
            } else {
                dispatch("receivingJob_positions"); // สถานะ กำลังบันทึก

                axios.get('/job_positions').then(res => {

                    dispatch("receiveJob_positions", res.data);
                })
                    .catch((e) => {
                        console.log(e);
                        dispatch("receiveJob_positions", null);
                    })
            }
        },
        loadJob_positionRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveJob_position", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingJob_position");
                axios.get('/job_positions/' + id).then(res => {
                    dispatch("receiveJob_position", res.data);
                })
            }
        },
        updateJob_positionRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingJob_position");
            axios.put('/job_positions/' + payload.job_position_code, payload).then(res => {
                dispatch("updateJob_position", res.data);
            })
        },
        createJob_positionRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingJob_position");
            axios.post('/job_positions', payload).then(res => {
                dispatch("receiveJob_position", res.data);
            })
        },
        deleteJob_positionRequest({dispatch}, payload) {

            dispatch("afterDeleteJob_position", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingJob_position", payload);

            axios.post('/delete_job_positions', payload).then(res => {
                dispatch("deleteJob_position", {job_position_code: payload.job_position_code, res: res});
            })


        },
        receiveJob_positions({commit}, payload) {
            commit("RECEIVED_JOB_POSITIONS", payload)
        },
        receivingJob_positions({commit}) {
            commit("RECEIVING_JOB_POSITIONS") //call matutions --> state.isReceiving = true;
        },
        receiveJob_position({commit}, payload) {
            commit("RECEIVED_JOB_POSITION", payload)
        },
        receivingJob_position({commit}) {
            commit("RECEIVING_JOB_POSITIONS") //call matutions --> state.isReceiving = true;
        },
        updateJob_position({commit}, payload) {
            commit("UPDATED_JOB_POSITION", payload)
        },
        updatingJob_position({commit}) {
            commit("UPDATING_JOB_POSITION") //  call matutions --> state.isUpdating = true;
        },
        deleteJob_position({commit}, payload) {
            commit("DELETED_JOB_POSITION", payload)
        },
        deletingJob_position({commit}, payload) {
            commit("DELETING_JOB_POSITION", payload)
        },
        afterDeleteJob_position({commit}, payload) {
            commit("AFFTER_DELETED_JOB_POSITION", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_JOB_POSITIONS(state, payload) {
            state.job_positions = payload;
            state.isReceiving = false;

        },
        RECEIVING_JOB_POSITIONS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_JOB_POSITION(state, payload) {


            if (payload.job_position_code == undefined) {
                let error = !payload.e.errorInfo==true?payload.message:payload.e.errorInfo.toString()
                let job_positionMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    job_positionMessage: (state.job_positionMessage == job_positionMessage ? job_positionMessage + ' ' : job_positionMessage),

                });
            } else {
                let job_positionMessage = 'บันทึกสำเร็จ! รายการ ' + payload.job_position_code + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    job_positions: [...state.job_positions, payload],
                    isReceiving: false,
                    errorMessage: false,
                    job_positionMessage: (state.job_positionMessage == job_positionMessage ? job_positionMessage + ' ' : job_positionMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_JOB_POSITION(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_JOB_POSITION(state, payload) {
            let index = state.job_positions.findIndex(p => p.job_position_code === payload.job_position_code);
            let job_positionMessage = 'บันทึกสำเร็จ! รายการ ' + payload.job_position_code + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                job_positions: state.job_positions.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,

                job_positionMessage: (state.job_positionMessage == job_positionMessage ? job_positionMessage + ' ' : job_positionMessage),
            })
        },
        UPDATING_JOB_POSITION(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_JOB_POSITION(state, payload) {


            if (payload.job_position_code == undefined || payload.res.data.message == 'Relation') {
                let job_positionMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.job_position_code;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    job_positionMessage: (state.job_positionMessage == job_positionMessage ? job_positionMessage + ' ' : job_positionMessage),
                });
            } else {
                let indexToDelete = state.job_positions.findIndex(p => p.job_position_code === payload.job_position_code);
                let job_positions = [...state.job_positions];
                job_positions.splice(indexToDelete, 1);
                let job_positionMessage = 'บันทึกสำเร็จ! รายการ ' + payload.job_position_code + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    job_positions: [...job_positions],
                    isDeleting: false,
                    idToDelete: null,

                    job_positionMessage: (state.job_positionMessage == job_positionMessage ? job_positionMessage + ' ' : job_positionMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_JOB_POSITION(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.job_position_code;
        },
        AFFTER_DELETED_JOB_POSITION(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
